import Joi from 'joi';

export const AppointmentSchema = Joi.object({
  name: Joi.string().required(),
  startDate: Joi.date().required(),
});
